import {
  createContext,
  useContext,
  useEffect,
  useId,
  useLayoutEffect,
} from "react";

// Scoped to the mounted application shell; never persist financial drafts.
export const RevenueDraftNavigationContext = createContext<Set<string> | null>(
  null,
);

export type RevenueDraftReporter = (id: string, dirty: boolean) => void;

export function useRevenueDraft(
  id: string,
  dirty: boolean,
  report: RevenueDraftReporter,
): void {
  const navigationDrafts = useContext(RevenueDraftNavigationContext);
  const navigationDraftId = useId();
  useLayoutEffect(() => {
    if (!dirty || !navigationDrafts) return;
    navigationDrafts.add(navigationDraftId);
    return () => {
      navigationDrafts.delete(navigationDraftId);
    };
  }, [dirty, navigationDraftId, navigationDrafts]);
  useEffect(() => report(id, dirty), [id, dirty, report]);
  useEffect(() => () => report(id, false), [id, report]);
  useEffect(() => {
    if (!dirty) return;
    const warnBeforeLeaving = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", warnBeforeLeaving);
    return () => window.removeEventListener("beforeunload", warnBeforeLeaving);
  }, [dirty]);
}
